var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.005 4.05a.552.552 0 0 0-.552.552v6.073a.552.552 0 0 0 .552.552h6.072a.552.552 0 0 0 .552-.552V7.363a.552.552 0 1 1 1.104 0v3.312a1.656 1.656 0 0 1-1.656 1.656H3.005a1.656 1.656 0 0 1-1.656-1.656V4.602a1.656 1.656 0 0 1 1.656-1.656h3.312a.552.552 0 1 1 0 1.104H3.005ZM7.973 1.842c0-.305.247-.552.552-.552h3.312c.305 0 .552.247.552.552v3.312a.552.552 0 0 1-1.104 0v-2.76h-2.76a.552.552 0 0 1-.552-.552Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.228 1.452a.552.552 0 0 1 0 .78L6.155 8.305a.552.552 0 1 1-.78-.78l6.072-6.073a.552.552 0 0 1 .78 0Z"
  })));
};

export default SvgExternalLink;